import M from "moment";
import * as R from "ramda";
import React, {Component} from "react";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import {mapToObjectDDL} from "../../../../common/mapper";
import {ACTIVITY_TYPE} from "../../../../common/Constants";
import {getSupplierExpOptions} from "../util";

class ReceivingUnitNOSInputs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReadonly: false
        }
    }

    componentDidMount() { 
        console.log(this.props)
        if(this.props.isEditable){
            this.setState({
                isReadonly: this.props.initialValues?.manual && this.props.initialValues.manual === "No"
            })
        }else{
            this.setState({
                isReadonly: true
            })
        }
     }

    handleInputDateChange = (name, value) => {
        const formattedDate = M(value).format("DD-MM-YYYY");
        this.props.setValue(name, formattedDate)
    };

    render() {
        return (
            <>
                <div className="grid grid-3x grid-mobile-none gap-15px">
                    <div id="grid-1">
                        <SimpleInput
                            id="input_text_nospbm"
                            name="spbmNo"
                            label="No. SPBM"
                            mandatory
                            readOnly
                            value={this.props.controls.spbmNo.value}
                        />
                        <SimpleInput
                            id="input_text_nosl"
                            name="slNo"
                            label="No. SL"
                            mandatory
                            errorMessage={this.props.errors.slNo}
                            readOnly={this.state.isReadonly}
                            value={this.props.controls.slNo.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleInput
                            id="input_text_noinvoice"
                            name="invoiceNo"
                            label="No. Invoice"
                            readOnly={this.state.isReadonly}
                            value={this.props.controls.invoiceNo.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                    </div>
                    <div id="grid-2">
                        <SimpleDate
                            id="select_date_tglspbm"
                            name="spbmDate"
                            label="Tgl. SPBM"
                            mandatory
                            nextdate
                            maxDate={M(new Date()).format("DD-MM-YYYY")}
                            disabled={this.state.isReadonly}
                            date={this.props.controls.spbmDate.value}
                            onChange={(value) => this.handleInputDateChange("spbmDate", value)}
                        />

                        <SimpleDate
                            id="select_date_tglsl"
                            name="slDate"
                            label="Tgl. SL"
                            mandatory
                            nextdate
                            maxDate={M(new Date()).format("DD-MM-YYYY")}
                            errorMessage={this.props.errors.slDate}
                            disabled={this.state.isReadonly}
                            date={this.props.controls.slDate.value}
                            onChange={(value) => this.handleInputDateChange("slDate", value)}
                        />

                        <SimpleInput
                            id="input_text_poid"
                            name="poId"
                            label="PO Id"
                            readOnly={this.state.isReadonly}
                            value={this.props.controls.poId.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                    </div>
                    <div id="grid-3">
                        <SimpleDDL
                            id="select_options_nama_supp"
                            name="kodeSupplier"
                            label="Nama Supp."
                            box={"search"}
                            mandatory
                            errorMessage={this.props.errors.kodeSupplier}
                            readOnly={this.state.isReadonly}
                            isClearable={true}
                            options={this.props.dataSupplier.length > 0
                                ? this.props.dataSupplier.map(
                                    item => mapToObjectDDL(
                                        item.supplierName,
                                        item.supplierCode
                                    )
                                )
                                : []
                            }
                            value={this.props.controls.kodeSupplier.value}
                            onChange={(value, {name}) =>
                                this.props.setValue(name, value)
                            }
                        />
                        <SimpleInput
                            id="input_text_no_pol_truk"
                            name="noPolisi"
                            label="No. Pol Truk"
                            readOnly={this.state.isReadonly}
                            value={this.props.controls.noPolisi.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleDDL
                            id="select_options_ekpedisi"
                            name="kodeSupplierExpedition"
                            box="search"
                            label="Ekspedisi"
                            readOnly={this.state.isReadonly}
                            isClearable={true}
                            options={this.props.dataSupplierExpedition.length > 0
                                ? getSupplierExpOptions(this.props.dataSupplierExpedition)
                                : []
                            }
                            value={
                                this.props.controls && Object.keys(this.props.controls).length > 0
                                    ? mapToObjectDDL(
                                        this.props.controls.kodeSupplierExpedition?.value?.label,
                                        this.props.controls.kodeSupplierExpedition?.value?.value,
                                    )
                                    : null
                            }
                            onChange={(value, {name}) =>
                                this.props.setValue(name, value)
                            }
                        />
                    </div>
                </div>
                <div
                    style={{
                        display: "grid",
                        gap: "15px",
                        gridTemplateColumns: "1fr 1fr",
                    }}
                >
                    <SimpleTextArea
                        typeInputCase="normal"
                        name="description"
                        label="Deskripsi"
                        readOnly={this.state.isReadonly}
                        value={this.props.controls.description.value}
                        onChange={({target}) =>
                            this.props.setValue(target.name, target.value)
                        }
                    />
                    <p style={{justifySelf: "end"}}>{this.props.controls.kodeSupplierExpedition?.value?.name}</p>
                </div>
            </>
        );
    }
}

export default ReceivingUnitNOSInputs;
